import React, { useState, useEffect } from 'react'
import { Navigate, useNavigate } from 'react-router-dom';
import ReactDOM from 'react-dom';
import HeaderCollapse from '../components/HeaderCollapse';
import HeaderCollapseMobile from '../components/HeaderCollapseMobile';
import {updateUserDisplayName} from '../config/Variables';
import Header from '../partials/Header';

function UpdateName(props) {


  const [name, setFirstname] = useState("");
  const [messagelog, setMessagelog] = useState("");
  const [last_name,setLastname] =useState();

  async function login() {
    if (name == "" ) {
      setMessagelog('الحقل فارغ الرجاء إدخال اسم الاول واسم العائلة');
    } else {
      let item = { name,last_name };
      if (localStorage.getItem('user-info')) {
        let user = JSON.parse(localStorage.getItem('user-info'))
        let result = await fetch(updateUserDisplayName, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": 'application/json',
            "Authorization": "Bearer " + user.token.access_token,
          },
          body: JSON.stringify(item)
        });
        user.user.first_name = name;
        user.user.last_name = last_name;
        
        user.user.name = name;
        user.user.display_name = name;
        
        result = await result.json();

        if (result.message.code == '401') {

        }
        if (result.message.code == '200') {
          localStorage.setItem('user-info', JSON.stringify(user));
   
          props.fetchownusercallback("success");


          var menu_collapse = document.getElementById("menu_collapse");
          if(menu_collapse){
          ReactDOM.render(
          <React.StrictMode>
          <HeaderCollapse />
          </React.StrictMode>,
          document.getElementById('menu_collapse')
          );
        }else{
          setMessagelog(result.message.message);
        }

        var menu_collapse = document.getElementById("menu_collapse_mobile");
        if(menu_collapse){
        ReactDOM.render(
        <React.StrictMode>
        <HeaderCollapseMobile />
        </React.StrictMode>,
        document.getElementById('menu_collapse_mobile')
        );
      }


        var domainurl=  window.location.origin;
       window.location.href = domainurl+'/journey#/personalize';
          

        }
        else {
          // navigate('/registersimple');
          setMessagelog(result.webmsg.message);
        }
      }
      //history('/add');

    }
  }
  if (!localStorage.getItem('user-info')) {

    return <Navigate to="/" />

  } else {
    return (
      <>
      <Header />
      <main>
        <div className="grid-x align-center">
          <div className="cell shrink">
            <div className="form-area-wrap padding-vertical-3">
              <div className="section-title margin-bottom-2">
                <h3>ادخل لحسابك أو اشترك</h3>
                <p>سجل للحصول على تجربة فريدة</p>
              </div>
              <div className="message alert text-center">
              {messagelog}
              </div>
              <div className="form-area">
            
                <div class="input-field input-default"> 
               
                    <input type="text" name="name" required="required" placeholder="الاسم الأول" onChange={(e) => setFirstname(e.target.value)} />
                    <div class="required">*</div>
                </div> 
                <div class="input-field input-default"> 
                    
                    <input type="text" name="last_name" required="required" placeholder="اسم العائلة" onChange={(e) => setLastname(e.target.value)} />
                    <div class="required">*</div>
                </div> 
                <button onClick={login} className="button submit-btn" >  تسجيل  </button>
              </div>
            </div>
          </div>
        </div>
        </main>
        </>
        
    );
  }
}

export default UpdateName;
